import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import MainButton from '../agv-button';
import Status from '../agv-status/index';

export default function Row({
  title,
  subtitle,
  iconColor,
  icon,
  onClick,
  buttonText,
  status,
  statusText,
  statusStyle,
  fields,
  style,
}) {
  // Calculer le nombre de colonnes nécessaires
  const fieldsCount = fields?.length || 0;
  const hasStatus = status && statusText;
  const hasButton = onClick && buttonText;
  const additionalColumns = (hasStatus ? 1 : 0) + (hasButton ? 1 : 0);
  const totalColumns = 1 + fieldsCount + additionalColumns; // 1 pour la colonne titre/icône

  // Créer le template de grille avec la première colonne double largeur et les 2 dernières en 0.5fr
  let gridTemplate = '2fr'; // Première colonne (titre/icône)
  
  if (fieldsCount + additionalColumns >= 2) {
    // S'il y a au moins 2 colonnes après la première
    if (fieldsCount + additionalColumns > 2) {
      // Colonnes du milieu en 1fr
      gridTemplate += ` repeat(${fieldsCount + additionalColumns - 2}, minmax(120px, 1fr))`;
    }
    // Deux dernières colonnes en 0.5fr
    gridTemplate += ' 0.5fr 0.5fr';
  } else if (fieldsCount + additionalColumns === 1) {
    // Une seule colonne après la première, elle fait 0.5fr
    gridTemplate += ' 0.5fr';
  }

  return (
    <div
      className={`tw-p-3 ${style}`}
      style={{
        display: 'grid',
        gridTemplateColumns: gridTemplate,
        gap: '1rem',
        alignItems: 'center',
      }}
      onClick={buttonText ? null : onClick}
      key={title}
    >
      {/* Première colonne : Icône et titre */}
      <div className="tw-flex tw-items-center tw-min-w-0">
        {icon && (
          <FontAwesomeIcon
            className={`tw-mr-2 tw-size-4 tw-flex-shrink-0 ${iconColor}`}
            icon={icon}
          />
        )}
        <div className="tw-min-w-0">
          <div className="tw-text-smi tw-font-work tw-leading-4 tw-mb-1 tw-truncate">
            {title}
          </div>
          <div className="tw-text-smi tw-font-work tw-text-text-dark-medium-importance tw-leading-4 tw-line-clamp-1">
            {subtitle}
          </div>
        </div>
      </div>

      {/* Colonnes pour les champs */}
      {fields?.map((field, index) => (
        <div key={`${field.name}-${index}`} className="tw-flex tw-flex-col tw-items-center tw-min-w-0">
          <div className="tw-text-smi tw-font-work tw-leading-4 tw-mb-1 tw-text-center tw-truncate tw-w-full">
            {field.name}
          </div>
          <div className="tw-text-smi tw-font-work tw-text-text-dark-medium-importance tw-leading-4 tw-line-clamp-1 tw-text-center tw-w-full">
            {field.icon && (
              <FontAwesomeIcon
                className={`tw-mr-1 tw-size-4`}
                icon={field.icon}
                color={field.color}
              />
            )}{' '}
            <span className="tw-truncate">{field.value}</span>
          </div>
        </div>
      ))}

      {/* Colonne pour le statut */}
      {hasStatus && (
        <div className="tw-flex tw-justify-center tw-min-w-0">
          <Status style={statusStyle} status={status} text={statusText} />
        </div>
      )}

      {/* Colonne pour le bouton */}
      {hasButton && (
        <div className="tw-flex tw-justify-center tw-min-w-0">
          <MainButton text={buttonText} onClick={onClick} />
        </div>
      )}
    </div>
  );
}
